module.exports = __webpack_public_path__ + "static/media/kjri_logo.45e58cef.png";